import { Link } from 'react-router-dom';
import type { BoatPlace, Boat } from '../lib/boats';
import ApprovalBadge from './ApprovalBadge';

interface Props {
  place: BoatPlace;
  boats: (Boat & { id: string })[];
}

export default function BoatPlaceCard({ place, boats }: Props) {
  return (
    <article className="bg-white rounded shadow p-4 mb-4">
      <h3 className="font-semibold text-lg">Plats {place.number}</h3>
      {boats.length === 0 ? (
        <p className="text-sm text-gray-500 mt-2">Inga båtar ännu</p>
      ) : (
        <ul className="mt-2 space-y-1">
          {boats.map((b) => (
            <li key={b.id} className="flex items-center gap-2">
              <Link to={`/mina-batar/${b.id}`} className="text-sky underline">
                {b.name ?? '(utan namn)'}
                {b.model && ` — ${b.model}`}
                {b.modelYear && ` (${b.modelYear})`}
              </Link>
              <ApprovalBadge approval={b.approval} />
            </li>
          ))}
        </ul>
      )}
      <Link
        to={`/mina-batar/ny?plats=${place.number}`}
        className="inline-block mt-3 text-sm text-sky underline"
      >
        + Lägg till båt
      </Link>
    </article>
  );
}
